import { baseAPI } from '@/api/axios';
import { MESSAGE_TYPE } from '@/utils';
import Axios from 'axios';

const getOptions = (
  tenantId,
  groupId = null,
  contentType = 'application/json'
) => {
  const headers = { 'Content-Type': contentType };
  if (tenantId) headers['TenantId'] = tenantId;
  if (groupId) headers['Group-Id'] = groupId;
  return { headers };
};

export default {
  createUser({ orgId, groupId, payload }) {
    const options = getOptions(orgId, groupId);
    return baseAPI.post('user/create', payload, options);
  },
  updateActiveState({ orgId, payload }) {
    const { userId, ...rest } = payload;
    const options = getOptions(orgId);
    return baseAPI.post(`user/${userId}/toggleActiveState`, rest, options);
  },
  // Handle csv upsert validation
  bulkUpsertValidate({ orgId, groupId, payload }) {
    const options = getOptions(orgId, groupId);
    return baseAPI.post(`user/BulkUpsertValidate`, payload, options);
  },
  // Handle .csv users user creation
  createCsvUsers({ orgId, groupId, payload }) {
    const options = getOptions(orgId, groupId);
    // Read Payload[0] to retrieve multiple arrays
    return baseAPI.post(`user/BulkUpsert`, payload[0], options);
  },
  getBulkCsvDownload({ orgId, groupId }) {
    const options = getOptions(orgId, groupId);
    return baseAPI.get('user/BulkCsvDownload', options);
  },
  getUsersHavingAssignedCourseIds({ orgId, groupId, payload }) {
    const options = getOptions(orgId, groupId);
    return baseAPI.post(
      'courseAssignment/GetUsersHavingAssignedCourseIds',
      payload,
      options
    );
  },

  /**
   * Admin unlocks user and sends password reset link to selected user
   * @param {string} email
   * @returns
   */
  adminResetPassword(payload) {
    return baseAPI.post(`Auth/adminResetPassword`, payload);
  },

  // baseAPI: external apis
  getDownloadInfo({ orgId, groupId }) {
    const options = getOptions(orgId, groupId);
    return baseAPI.get('assets/GetLatestReleaseInfo', options);
  },

  getCurrentUserSelf({ orgId, groupId, includeRedemptionCode }) {
    const options = getOptions(orgId, groupId);
    return baseAPI.get(
      `user/self${includeRedemptionCode ? '?includeRedemptionCode=true' : ''}`,
      options
    );
  },

  getAutoLoginToken() {
    return baseAPI.post('/user/self/generateAutoLoginToken');
  },

  assignRedemptionCode({ orgId, groupId, payload }) {
    const options = getOptions(orgId, groupId);
    return baseAPI.post('assets/assignRedemptionCode', payload, options);
  },
  getOfflineStatus() {
    return baseAPI.get('assets/offlineStatus', getOptions());
  },
  downloadAndroid({ orgId, groupId }) {
    const options = getOptions(orgId, groupId);
    return baseAPI.post('/downloads/androidApp', options);
  },
  downloadWindows({ orgId, groupId }) {
    const options = getOptions(orgId, groupId);
    return baseAPI.post('/downloads/windowsApp', options);
  },
  getNotificationsForUser({ orgId, groupId }) {
    const options = getOptions(orgId, groupId);
    return baseAPI.get(`/notification`, options);
  },
  getFaqUrl(role) {
    return baseAPI.get(role ? `/Assets/FaqUrl?role=${role}` : '/Assets/FaqUrl');
  },
  getAssetByUrl(url) {
    return Axios.get(url);
  },
  declareAnswerOverrideAuthorization({ orgId, courseUnifierId }) {
    return baseAPI.post(
      `/user/self/declareAnswerOverrideAuth`,
      { courseUnifierId },
      getOptions(orgId)
    );
  },
  getUserName(id) {
    return baseAPI.get(`User/${id}/name`);
  },
  getBannerMessages({ orgId, groupId }) {
    const options = getOptions(orgId, groupId);
    return baseAPI.get(
      `AppMessages/pending?type=${MESSAGE_TYPE.BANNER}&unreadByUserOnly=true`,
      options
    );
  },
  viewedAppMessage(id) {
    return baseAPI.post(`AppMessages/${id}/markViewed`);
  },
  readAppMessage(id) {
    return baseAPI.post(`AppMessages/${id}/markRead`, {
      appMessageId: id,
    });
  },
  marketingMessageBtnClick(id) {
    return baseAPI.post(`AppMessages/${id}/logButtonClicked`, {
      appMessageId: id,
    });
  },
  getMarketingMessages({ orgId, groupId }) {
    const options = getOptions(orgId, groupId);
    return baseAPI.get(`/AppMessages/marketing/client`, options);
  },
};
